import { useState } from "react";
import ContactPhoneFields, {
  shouldShowContactPhoneFields,
} from "./ContactPhoneFields";
import formEmailMetadata from "../data/form-email-metadata.json";
import "./InterestForm.css";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/mrgnqryj";

export default function InterestForm({ variant = "interest" }) {
  const [status, setStatus] = useState("idle");
  const isContact = variant === "contact";
  const isSupport = variant === "support";
  const showsSplitName = isContact;
  const route = isContact ? "/contact" : isSupport ? "/support" : "/";
  const emailMetadata = formEmailMetadata[route];
  const showsPhoneFields = shouldShowContactPhoneFields(route);

  if (status === "success") {
    return (
      <div className="interest-form__success" role="status">
        {isContact ? (
          <p>Thank you!</p>
        ) : isSupport ? (
          <p>Thank you. Your support request has been sent.</p>
        ) : (
          <>
            <p>Thank you for submitting your interest in 10k Science!</p>
            <p>Our team will be in touch with you soon.</p>
          </>
        )}
      </div>
    );
  }

  return (
    <form
      action={FORMSPREE_ENDPOINT}
      className={`interest-form interest-form--${variant}`}
      method="POST"
      onSubmit={async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        setStatus("submitting");

        try {
          const response = await fetch(FORMSPREE_ENDPOINT, {
            body: new FormData(form),
            headers: { Accept: "application/json" },
            method: "POST",
          });

          if (!response.ok) throw new Error("Formspree rejected the form.");
          form.reset();
          setStatus("success");
        } catch {
          setStatus("error");
        }
      }}
    >
      <input name="subject" type="hidden" value={emailMetadata.subject} />
      <input
        name="form_name"
        type="hidden"
        value={emailMetadata.formName}
      />
      {showsSplitName && (
        <fieldset className="interest-form__name">
          <legend>Name</legend>
          <label>
            <span>First Name</span>
            <input autoComplete="given-name" name="fname" type="text" />
          </label>
          <label>
            <span>Last Name</span>
            <input autoComplete="family-name" name="lname" type="text" />
          </label>
        </fieldset>
      )}

      <label>
        <span>
          Email <small>(required)</small>
        </span>
        <input autoComplete="email" name="email" required type="email" />
      </label>
      <label>
        <span>School / Organization</span>
        <input name="organization" type="text" />
      </label>
      {!showsSplitName && (
        <label>
          <span>Name</span>
          <input autoComplete="name" name="name" type="text" />
        </label>
      )}
      {showsPhoneFields && <ContactPhoneFields />}
      {isSupport && (
        <div className="interest-form__device-details">
          <label>
            <span>App version</span>
            <input name="app_version" type="text" />
          </label>
          <label>
            <span>Device model and iOS version</span>
            <input name="device_and_ios_version" type="text" />
          </label>
        </div>
      )}
      <label>
        <span>
          Message {isSupport && <small>(required)</small>}
        </span>
        <textarea name="message" required={isSupport} rows="6" />
      </label>
      {status === "error" && (
        <p className="interest-form__error" role="alert">
          Ooops! There was an error. Please try again.
        </p>
      )}
      <button
        className="button-link button-link--outline"
        disabled={status === "submitting"}
        type="submit"
      >
        {status === "submitting"
          ? "Sending…"
          : isContact || isSupport
            ? "Send"
            : "Submit"}
      </button>
    </form>
  );
}
